import { Link, useLocation } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';
import { NAVIGATION } from '@/routes/navigation';

const ALL_ITEMS = NAVIGATION.flatMap((group) => group.items);

function titleCase(segment: string): string {
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) {
    return <h1 className="font-display text-lg font-bold text-text-primary">Dashboard</h1>;
  }

  const matched = ALL_ITEMS.find((item) => item.path === location.pathname);
  const pageTitle = matched?.label ?? titleCase(segments[segments.length - 1]);

  return (
    <div>
      <h1 className="font-display text-lg font-bold text-text-primary">{pageTitle}</h1>
      <nav className="mt-0.5 flex items-center gap-1.5 text-xs text-text-tertiary">
        <Link to="/" className="hover:text-text-secondary">
          Dashboard
        </Link>
        {segments.map((segment, index) => {
          const path = '/' + segments.slice(0, index + 1).join('/');
          const isLast = index === segments.length - 1;
          return (
            <span key={path} className="flex items-center gap-1.5">
              <IconChevronRight className="h-3.5 w-3.5" />
              {isLast ? (
                <span className="text-text-secondary">{titleCase(segment)}</span>
              ) : (
                <Link to={path} className="hover:text-text-secondary">
                  {titleCase(segment)}
                </Link>
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
}
